import { ConfigBillView as BillView } from './Bill';
import { ConfigPaidBillsView as PaidBillView } from './Paid';
import { ConfigUnpaidBillsView as UnpaidBillView } from './Unpaid';
import { ConfigOverviewView as Overview} from './Overview';
import { ConfigBillableView as BillableView} from './Billable';
import { ConfigBillingView } from './Billing';
import { ConfigCreateUpdateBill as CreateUpdateBill } from './CreateUpdate'

export { Overview, BillView,PaidBillView, UnpaidBillView, CreateUpdateBill, BillableView };
export default ConfigBillingView;